const { getElement, viewportSize } = window.BAO.Utils
class LazyVideo extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: flex;

        opacity: 0;

        transition: opacity 0.5s ease;
      }
      :host([loaded]) {
        opacity: 1;
      }
    `
  }

  connectedCallback () {
    super.connectedCallback()

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      threshold: 0,
    })
    // We need to observe the video element as the host element has display: contents on it. IntersectionObserver won't work on an element that is set to display: contents
    this.observer.observe(this.video)
  }

  setupListeners () {
    super.setupListeners()
    if (this.video.hasAttribute('autoplay')) {
      this.listeners.add(this.video, 'playing', () => {
        this.toggleAttribute('loaded', true)
      })
    } else {
      this.listeners.add(this.video, 'canplay', () => {
        this.toggleAttribute('loaded', true)
      })
    }
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    if (this.hasAttribute('data-await-visibility-of-parent')) {
      const parentEl = this.closest(this.dataset.awaitVisibilityOfParent)
      if (!parentEl) return
      const visibilityInterval = setInterval(() => {
        if (
          getComputedStyle(parentEl).getPropertyValue('visibility') ===
          'visible'
        ) {
          this.loadVideo(observer)
          clearInterval(visibilityInterval)
        }
      }, 300)
      return
    }

    this.loadVideo(observer)
  }

  loadVideo (observer) {
    if (this.video.hasAttribute('data-poster')) {
      this.video.setAttribute('poster', this.video.dataset.poster)
    }

    for (const source in this.video.children) {
      const videoSource = this.video.children[source]

      if (
        typeof videoSource.tagName === 'string' &&
        videoSource.tagName === 'SOURCE' &&
        videoSource.hasAttribute('data-src')
      ) {
        videoSource.src = videoSource.dataset.src
        this.video.load()
        this.toggleAttribute('loaded', true)
      }
    }

    observer.unobserve(this.video)

    if (
      viewportSize() !== `xs` ||
      this.video.hasAttribute('autoplay') === false
    ) {
      return
    }

    if (this.video.paused) {
      document.addEventListener('touchstart', () => {
        if (this.video.paused) {
          this.video.play()
        }
      })
    }
  }

  get video () {
    return getElement('video', { context: this })
  }
}

if (!customElements.get('lazy-video')) {
  customElements.define('lazy-video', LazyVideo)
}
